export default __webpack_public_path__ + "static/media/i228sp.ca2ed36f.webp";